class TrackingCookie {
  static COOKIE_KEY = 'bump_marketing_tracking';

  constructor() {
    this.request = {
      path: window.location.pathname,
      originalUrl: window.location.href,
      referer: document.referrer || null,
      host: window.location.hostname,
      queryParameters: this.getQueryParameters()
    };
  }

  storeData() {
    if (!this.hasData()) {
      this.writeCookie(JSON.stringify(this.data()));
    }
  }

  hasData() {
    const data = this.readData();
    return Object.keys(data).length > 0;
  }

  readData() {
    try {
      const data = this.readCookie();
      return data ? JSON.parse(data) : {};
    } catch {
      this.deleteCookie();
      return {};
    }
  }

  data() {
    const baseData = {
      first_seen_at: new Date().toISOString(),
      first_seen_path: this.request.path,
      first_seen_url: this.request.originalUrl,
      referer: this.request.referer
    };

    return this.compact({ ...baseData, ...this.utmData() });
  }

  utmData() {
    const utmParams = [
      'utm_campaign',
      'utm_source',
      'utm_medium',
      'utm_content',
      'utm_term'
    ];

    const result = {};
    utmParams.forEach(param => {
      if (this.request.queryParameters[param]) {
        result[param] = this.request.queryParameters[param];
      }
    });

    return result;
  }

  getQueryParameters() {
    const params = {};
    new URLSearchParams(window.location.search).forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }

  writeCookie(value) {
    if (this.getCookie('bump_cookie_consent') === 'false') {
      return;
    }

    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);

    document.cookie = `${TrackingCookie.COOKIE_KEY}=${encodeURIComponent(value)}; domain=${this.request.host}; secure; expires=${expires.toUTCString()}; path=/`;
  }

  readCookie() {
    const value = this.getCookie(TrackingCookie.COOKIE_KEY);
    return value ? decodeURIComponent(value) : null;
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop().split(';').shift() : null;
  }

  deleteCookie() {
    document.cookie = `${TrackingCookie.COOKIE_KEY}=; domain=${this.request.host}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  }

  compact(obj) {
    const result = {};
    Object.entries(obj).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        result[key] = value;
      }
    });
    return result;
  }
}

export const init = () => {
  const marketingTracking = new TrackingCookie();
  marketingTracking.storeData();
};
